<div class="color-bar"></div>

<div class="conteudo">

  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>NBS Informática</title>
    <link rel="stylesheet" href="sobre-lista.component.css">
    <script src="script.js" defer></script>
  </head>

  <body>
    <p class="titulo">NBS Informática - Portal NBS - Histórico de Versões</p>
    <div *ngFor="let item of dadosJSON">
      <table class="cabVersao">
        <tr>
          <td colspan="8">
            <table class="cabVersao">
              <tr>
                <td bgcolor="#F2F2F2">Versão: <strong>{{ item?.versao_modulo }}</strong></td>
                <td bgcolor="#E5E5E5">Lote: <strong>{{ item?.lote }}</strong></td>
                <td bgcolor="#F2F2F2">Data: <strong>{{ item?.data }}</strong></td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="cabEvento">
          <td class="colEvento">Evento</td>
          <td class="colTipo">Tipo</td>
          <td class="colDescricao">Descrição</td>
        </tr>  
        <tr *ngFor="let evento of item?.eventos" class="linha-evento">
          <td>{{ evento?.cod_evento }}</td>
          <td>{{ evento?.tipo }}</td>
          <td [innerHTML]="evento?.descricao.replaceAll('\n','<br/>')"></td>
        </tr>
      </table>
      <br>
    </div>
  </body>
</div>
